const CheckIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#258900"
      d="M16 8a7.975 7.975 0 0 1-.625 3.156 8.13 8.13 0 0 1-1.719 2.531 7.923 7.923 0 0 1-2.531 1.688c-.98.417-2.02.625-3.125.625a7.975 7.975 0 0 1-3.156-.625 8.13 8.13 0 0 1-2.532-1.719 8.41 8.41 0 0 1-1.687-2.531A7.897 7.897 0 0 1 0 8c0-1.104.208-2.146.625-3.125a8.363 8.363 0 0 1 1.719-2.531A8.032 8.032 0 0 1 4.906.625 7.82 7.82 0 0 1 8 0c1.104 0 2.146.208 3.125.625.98.417 1.823.99 2.531 1.719a7.674 7.674 0 0 1 1.719 2.531c.417.98.625 2.02.625 3.125Zm-3.688-2.719a.503.503 0 0 0 .063-.218c0-.063-.031-.125-.094-.188L11.156 3.75a.297.297 0 0 0-.25-.125c-.104 0-.187.052-.25.156l-3.25 5.406h-.125L5.094 7.563c-.084-.063-.157-.094-.219-.094a.212.212 0 0 0-.156.062.363.363 0 0 1-.063.094L3.75 8.906c-.063.063-.094.125-.094.188 0 .104.052.187.156.25l3.532 2.969c.041.041.114.062.218.062a.297.297 0 0 0 .25-.125l4.5-6.969Z"
    />
  </svg>
)
export default CheckIcon
